import React, { useState } from 'react';
import { TextField, Typography, Container, Grid, Button, Alert } from '@mui/material';
import Navbar from './Navbar'; // Import the Navbar component

const ContactPage = ({ isLocked }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (isLocked) {
            // Simulate a successful submission without sending data to the backend
            setTimeout(() => {
                setSuccess(true);
                setLoading(false);
                resetForm();
            }, 1000);
            return;
        }

        // Simulate backend interaction
        setTimeout(() => {
            setSuccess(true);
            setLoading(false);
            resetForm();
        }, 1000);
    };

    const resetForm = () => {
        setName('');
        setEmail('');
        setMessage('');
    };

    return (
        <>
            <Navbar />
            <Container>
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        fontFamily: "'Brilon', sans-serif",
                        textAlign: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                    }}
                >
                    Contact Us
                </Typography>
                {success && (
                    <Alert severity="success" sx={{ marginBottom: '20px', fontFamily: "'Brilon', sans-serif" }}>
                        Your message has been sent!
                    </Alert>
                )}
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Name"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputLabelProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Email"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputLabelProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Message"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                                multiline
                                rows={4}
                                InputProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                                InputLabelProps={{
                                    style: { fontFamily: "'Brilon', sans-serif" },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                sx={{
                                    marginTop: '20px',
                                    fontFamily: "'Brilon', sans-serif",
                                    backgroundColor: '#614a94',
                                    '&:hover': {
                                        backgroundColor: '#4a3573',
                                    },
                                }}
                                disabled={loading}
                            >
                                {loading ? 'Submitting...' : 'Submit'}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Container>
        </>
    );
};

export default ContactPage;